module.exports = __webpack_public_path__ + "img/901485242.b0a36e89.png";